<template>
  <div>
    <main role="main">
      <section class="px-5">
        <div class="container is-max-desktop">
          <div class="columns is-multiline mb-2">
            <div class="column is-full">
              <nav class="breadcrumb" aria-label="Breadcrumb">
                <ol>
                  <li><a href="#" title="Inicio" class="text-acc">Inicio</a></li>
                  <li><a href="red-de-atencion" title="Momentos de vida" class="text-acc">Red de atención</a></li>
                  <li><span class="text-acc">Videoatención</span></li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section class="has-background-grey p-5">
        <div class="container is-max-desktop">
          <div class="columns is-multiline">
            <div class="column is-half">
              <header>
                <h1 class="has-gob-title"></h1>
                <span class="is-lower-text-title text-acc">Sucursal Virtual</span>
                <h1 class="has-gob-title text-acc" style="background-image: none !important; padding-top: 5px !important;">Solicitud de videoatención para {{ tramite_name }}</h1>
              </header>
            </div>
          </div>
        </div>
      </section>

      <section class="section p-5" style="margin-top: 0px !important;">
        <div class="container is-max-desktop">
          <div class="columns is-multiline">
            <div class="column is-full is-two-thirds-tablet">
              <!-- Mensajes de estado -->
              <section v-if="contingencia == 1">
                <div class="msg msg-info mb-5 text-acc" role="alert" aria-label="Cuadro de información importante">
                  <h4>Sucursal Virtual no disponible</h4>
                  <p v-html="texto(message_contingencia)"></p>
                </div>
              </section>
              
              <section v-else-if="capacitacion == 1">
                <div class="msg msg-info mb-5 text-acc" role="alert" aria-label="Cuadro de información importante">
                  <h4>Sucursal Virtual no disponible</h4>
                  <p v-html="texto(message_capacitacion)"></p>
                </div>
              </section>
              
              <section v-else-if="feriado == 1">
                <div class="msg msg-info mb-5 text-acc" role="alert" aria-label="Cuadro de información importante">
                  <h4>Horario de atención</h4>
                  <p v-html="texto(message_feriado)"></p>
                </div>
              </section>
              
              <section v-else-if="feriado_m == 1">
                <div class="msg msg-info mb-5 text-acc" role="alert" aria-label="Cuadro de información importante">
                  <h4>Horario de atención</h4>
                  <p v-html="texto(message_feriado_medio)"></p>
                </div>
              </section>
              
              <section v-else-if="feriado_m == 0 && feriado == 0 && activo == 0">
                <div class="msg msg-info mb-5 text-acc" role="alert" aria-label="Cuadro de información importante">
                  <h4>Horario de atención</h4>
                  <p v-html="texto(message_inactive)"></p>
                </div>
              </section>

              <!-- Formulario principal -->
              <div v-if="activo == 1 && !hasStatusMessage" id="form_global" role="form">
                <p class="mb-5 text-acc">Antes de iniciar, ten presente estas condiciones:</p>

                <ul class="list mb-5 text-acc">
                  <li><strong>Tener tu cédula de identidad vigente</strong>, la que deberás mostrar al ejecutivo o ejecutiva.</li>
                  <li><strong>Debes poder hablar y expresar tu voluntad sin dificultades</strong>, para mantener una conversación fluida.</li>
                  <li><strong>No conduzcas ni te muevas entre lugares o habitaciones</strong> mientras se realiza la llamada.</li>
                  <li><strong>La videollamada será grabada</strong>, así que mantén una comunicación clara y respetuosa, como en una sucursal presencial.</li>
                </ul>

                <div class="msg msg-info mb-5 text-acc" role="alert" aria-label="Cuadro de información importante">
                  <h4>Horario de atención</h4>
                  <p class="mb-0">Lunes a viernes de <strong>8:00 a 17:00 horas</strong>.</p>
                </div>

                <h2 class="has-gob-title mb-4">Ingresa tus datos</h2>

                <form @submit.prevent="submit()" class="this-form">
                  <div class="form-sector p-5 mb-5">
                    <div class="field form-uikit mb-4">
                      <label for="input_nombre_apellido" class="label text-acc">
                        Nombre y apellido *
                      </label>
                      <div class="control">
                        <input 
                          type="text" 
                          required="required" 
                          class="input" 
                          placeholder="Ingresa tu nombre y apellido"
                          v-model="data.name"
                          id="input_nombre_apellido"
                          name="name"
                          v-validate="'required'">
                      </div>
                      <span class="help text-acc" v-show="errors.has('name')">
                        El campo nombre y apellido no puede estar vacío
                      </span>
                      <span class="help2 text-acc" v-show="!errors.has('name')">
                        Ejemplo: María Cortés Espinoza
                      </span>
                    </div>

                    <div class="field form-uikit mb-4">
                      <label for="rut" class="label">
                        RUN *
                      </label>
                      <div class="control text-acc">
                        <input 
                          type="text" 
                          required="required" 
                          class="input text-acc" 
                          placeholder="Ingresa tu RUN"
                          v-model="data.rut"
                          id="rut"
                          name="rut"
                          v-validate="'required|rut'"
                          @keyup="formatRut()">
                      </div>
                      <span class="help text-acc" v-show="errors.has('rut')">
                        Ingrese un RUN válido
                      </span>
                      <span class="help2 text-acc" v-show="!errors.has('rut')">
                        Ejemplo: 12.345.678-9
                      </span>
                    </div>

                    <div class="field form-uikit mb-4" v-if="!tramite_sin_nserie">
                      <label for="nserie" class="label text-acc">
                        Número de documento de la cédula de identidad *
                      </label>
                      <div class="control">
                        <input 
                          type="text" 
                          required="required" 
                          class="input" 
                          placeholder="Ingresa tu N° de documento"
                          v-model="data.nserie"
                          id="nserie"
                          name="nserie"
                          v-validate="'required'"
                          maxlength="9"
                          @keypress="isValidCharSerie($event)"
                          @input="convertToUpperCase">
                      </div>
                      <span class="help text-acc" v-show="errors.has('nserie')">
                        Debe ingresar un número de documento
                      </span>
                      <span class="help2 text-acc" v-show="!errors.has('nserie')">
                        Ejemplo: 123.456.789
                      </span>
                    </div>

                    <div class="field form-uikit text-acc">
                      <label for="input_email" class="label">
                        Correo electrónico *
                      </label>
                      <div class="control">
                        <input 
                          type="text" 
                          required="required" 
                          class="input" 
                          placeholder="Ingresa tu correo electrónico"
                          v-model="data.email"
                          id="input_email"
                          name="email"
                          v-validate="'required|email'">
                      </div>
                      <span class="help text-acc" v-show="errors.has('email')">
                        Ingrese un correo electrónico válido
                      </span>
                      <span class="help2 text-acc" v-show="!errors.has('email')">
                        Ejemplo: nombre@gmail.com
                      </span>
                    </div>

                    <div class="field mt-2 mb-4 text-acc">
                      <label class="b-checkbox checkbox text-acc" id="checkbox_example">
                        <input 
                          id="" 
                          type="checkbox" 
                          autocomplete="on" 
                          true-value="true"
                          aria-labelledby="checkbox_example" 
                          value="false"
                          v-model="data.checkbox"
                          v-validate="'required'">
                        <!-- <span class="check is-info text-acc"></span> -->
                        <span id="checkbox_example" class="control-label text-acc">
                          <strong>Declaro que la identidad y los datos son verdaderos. Acepto las sanciones </strong>en caso de presentar
                          documentación falsa, y el uso de la grabación como medio de prueba. Asimismo, <strong>tomo conocimiento que la llamada será finalizada
                            si no mantengo una comunicación respetuosa</strong> con la persona que atenderá mi solicitud.
                        </span>
                      </label>
                    </div>

                    <p class="mb-4 text-acc">Los campos marcados con (*) son obligatorios.</p>

                    <!-- Mensaje de error -->
                    <div class="msg msg-danger mb-4 text-acc" role="alert" aria-label="Cuadro de información importante" v-if="errorCI">
                      {{ messageCI }}
                    </div>

                    <div class="columns">
                      <div class="column text-acc">
                        <button 
                          type="button" 
                          class="button is-default is-fullwidth-mobile text-acc"
                          @click="prevStep">
                          Revisar otros trámites
                        </button>
                      </div>
                      <div class="column has-text-right-tablet text-acc">
                        <button 
                          type="button" 
                          class="button is-primary text-acc"
                          @click="enviarFormulario"
                          :loading="fetchingData"
                          :disabled="errors.has('rut') || errors.has('name') || errors.has('email') || (!tramite_sin_nserie && errors.has('nserie')) || (data.rut == null) || (data.name == null) || (data.email == null) || (!tramite_sin_nserie && data.nserie == null) || (!tramite_sin_nserie && data.nserie && data.nserie.length < 9) || (data.checkbox == false)">
                          Solicitar videoatención
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

                <p class="text-acc">Después de la videoatención, deberás completar una encuesta sobre la calidad del servicio y la atención, lo que nos permitirá seguir mejorando.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import { rutValidator, rutFilter, rutInputDirective } from "vue-dni";
import ElButton from 'element-ui/lib/button';

import es from 'vee-validate/dist/locale/es';
Vue.use(VeeValidate);

Vue.filter("rutFilter", rutFilter);
Vue.directive("rut", rutInputDirective);
Validator.extend("rut", rutValidator);

export default {
  data() {
    return {
      data: {
        name: null,
        rut: null,
        email: null,
        nserie: null,
        checkbox: ''
      },
      fetchingData: false,
      errorCI: false,
      messageCI: null,
      errorEndpointCI: false
    }
  },
  mounted(){
    if (this.tramite_sin_nserie == 1) {
      this.data.nserie = "";
    }
  },
  computed: {
    hasStatusMessage() {
      // Verificar si hay algún mensaje de estado activo
      return this.contingencia == 1 || 
             this.capacitacion == 1 || 
             this.feriado == 1 || 
             this.feriado_m == 1 || 
             (this.feriado_m == 0 && this.feriado == 0 && this.activo == 0);
    }
  },
  components: { ElButton },
  props: [
    "tramite",
    "tramite_name",
    "contingencia",
    "capacitacion",
    "activo",
    "feriado",
    "feriado_m",
    "message_contingencia",
    "message_capacitacion",
    "message_inactive",
    "message_feriado",
    "message_feriado_medio",
    "titulo",
    "descripcion",
    "tramite_sin_nserie"
  ],

  methods: {
    texto(message_received){
      return `${message_received}`
    },
    formatRut() {
      let clearRut = typeof this.data.rut === "string" ? this.data.rut.replace(/[^0-9kK]+/g, "").toUpperCase() : "";
      if (clearRut.length <= 1) {
        return false;
      }
      var result = clearRut.slice(-4, -1) + "-" + clearRut.substr(clearRut.length - 1);
      for (var i = 4; i < clearRut.length; i += 3) {
        result = clearRut.slice(-3 - i, -i) + "." + result;
      }
      this.data.rut = result;
      let rut = this.data.rut;
      if (typeof rut !== "string") {
        return false;
      }
      rut = typeof this.data.rut === "string" ? this.data.rut.replace(/[^0-9kK]+/g, "").toUpperCase() : "";
      var rutDigits = parseInt(rut.slice(0, -1), 10);
      var m = 0;
      var s = 1;
      while (rutDigits > 0) {
        s = (s + (rutDigits % 10) * (9 - (m++ % 6))) % 11;
        rutDigits = Math.floor(rutDigits / 10);
      }
      var checkDigit = s > 0 ? String(s - 1) : "K";
      if (checkDigit === rut.slice(-1)) {
        this.errores = false;
      } else {
        this.errores = true;
      }
    },
    prevStep() {
      let url = '/sucursalvirtual'
      window.location.replace(url);
    },

    isValidCharSerie(event) {
      const char = String.fromCharCode(event.which);
      if (!(/[0-9a-zA-Z]/i.test(char))) {
        event.preventDefault();
      }
    },
    
    validateNumeroSerie(numeroSerie) {
      if (!numeroSerie || numeroSerie.trim() === '') {
        return { isValid: false, message: 'El número de documento es obligatorio' };
      }
      
      const cleaned = numeroSerie.trim();
      
      if (cleaned.length < 3) {
        return { isValid: false, message: 'El número de documento debe tener al menos 3 caracteres' };
      }
      
      if (cleaned.length > 9) {
        return { isValid: false, message: 'El número de documento no puede exceder 9 caracteres' };
      }
      
      if (!/^[0-9A-Z]+$/i.test(cleaned)) {
        return { isValid: false, message: 'El número de documento solo puede contener números y letras' };
      }
      
      return { isValid: true, message: '' };
    },

    convertToUpperCase() {
      if (this.data.nserie) {
        this.data.nserie = this.data.nserie.toUpperCase();
        // this.validateNserieField();
      }
    },

    async validarCI() {
      if (!this.data.rut || !this.data.nserie) {
        return;
      }

      try {
        this.fetchingData = true;

        const rutLimpio = this.data.rut.replace(/\./g, '').replace(/-/g, '');

        const run = rutLimpio.slice(0, -1);
        const dv = rutLimpio.slice(-1);

        // const base_url = process.env.MIX_JUNAR_COW_URL
        // const url = base_url+`rundv/${run}${dv}/numserie/${this.data.nserie}/tipodocumento/CEDULA/`;
        const url = "/api/sucursalvirtual/verificar-rut-cni";
console.log(url);
        const response = await axios.post(url,
          {
            rut: `${run}-${dv}`,
            numSerie: this.data.nserie
          },
          {
            headers: {
              // 'Authorization': process.env.MIX_JUNAR_COW_SECRET,
              'Content-Type': 'application/json'
            }
          }
        );

        // console.log('Respuesta validación:', response.data);
        // console.log('codigo:', response.data.codigoRetorno);
        // console.log('glosa:', response.data.glosaRetorno);

        if (response.data.glosaRetorno != "OK") {
          this.errorEndpointCI = true;
        }else{
          this.errorEndpointCI = false;
        }

      } catch (error) {
        console.error('Error validando CI:', error);
        this.errorCI = true;
        this.messageCI = 'No se pudo validar la cédula. Intente nuevamente.';
      } finally {
        this.fetchingData = false;
      }
    },
    enviarFormulario() {
      // if (!this.tramite_sin_nserie && this.data.nserie) {
      //   const validation = this.validateNumeroSerie(this.data.nserie);
      //   if (!validation.isValid) {
      //     this.errorCI = true;
      //     this.messageCI = validation.message;
      //     return;
      //   }
      //   this.validarConServicioAntesDeEnviar();
      //   return;
      // }
      this.procesarEnvioFormulario();
    },

    validarConServicioAntesDeEnviar() {
      this.fetchingData = true;
      this.errorCI = false;
      this.messageCI = null;

      const params = new FormData();
      params.append('rut', this.data.rut);
      params.append('nserie', this.data.nserie);

      axios.post('/api/validar-numero-documento', params, {
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          this.fetchingData = false;
          
          if (response.data.success) {
            this.procesarEnvioFormulario();
          } else {
            this.errorCI = true;
            this.messageCI = response.data.message;
          }
        })
        .catch((error) => {
          this.fetchingData = false;
          this.errorCI = true;
          this.messageCI = 'Error al validar el documento';
        });
    },

    procesarEnvioFormulario() {
      this.fetchingData = true;
      let params = new FormData();
      params.append('id_tramite', this.tramite);
      params.append('tramite_name', this.tramite_name); 
      params.append('nombre', this.data.name);
      params.append('rut', this.data.rut);
      params.append('email', this.data.email);
      params.append('pcqueue', 'portal');
      
      // Solo enviar nserie si el trámite lo requiere
      if (this.tramite_sin_nserie != 1 && this.data.nserie) {
        params.append('nserie', this.data.nserie);
      }

      // Enviar a la ruta del proxy en Laravel
      const url = '/api/procesar-formulario-sucursal-virtual';
      
      axios.post(url, params, {
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          console.log('Formulario enviado:', response);
          
          if (response.data.success) {
            // Si el token se generó correctamente, redirigir a la pantalla de espera
            const redirectUrl = response.data.redirect_url;
            if (redirectUrl) {
              window.location.href = redirectUrl;
            } else {
              this.errorCI = true;
              this.messageCI = 'Error: No se recibió URL de redirección';
              this.fetchingData = false;
            }
          } else {
            this.errorCI = true;
            this.messageCI = response.data.message || 'Error al procesar el formulario';
            this.fetchingData = false;
          }
        })
        .catch((error) => {
          console.log('Error:', error);
          this.fetchingData = false;
          
          if (error.response && error.response.data) {
            if (error.response.status === 422) {
              // Errores de validación
              let allErrors = '';
              for (let key in error.response.data.errors) {
                allErrors += error.response.data.errors[key].join(' ') + ' ';
              }
              this.errorCI = true;
              this.messageCI = allErrors;
            } else {
              // Otros errores
              this.errorCI = true;
              this.messageCI = error.response.data.message || 'Error de conexión inesperado';
            }
          } else {
            this.errorCI = true;
            this.messageCI = 'Error de conexión inesperado. Por favor, inténtelo nuevamente.';
          }
        });
    }
  },
};
</script>

<style scoped>
.button.is-primary[disabled], fieldset[disabled] .button.is-primary {
  /* background-color: rgb(12 48 154); */
  background-color: #0F69B4 ;
  opacity: 50%;
  border-color: rgb(0 0 0 / 0%);
  box-shadow: none;
}

.el-button {
  background-color: rgb(15 105 180);;
  border-color: rgb(0 0 0 / 0%);
  box-shadow: none;
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  border-radius: 0;
  padding: 15px 55px;
  position: relative;
  cursor: pointer;
  font-size: 16px;
  height: auto!important;
  -webkit-appearance: auto;
  line-height: initial;
}
.this-form{
  background-color: #f7f7f7 !important;
}

.help2{
  color: #0F69C4;
}

.text-error{
  color: red;
  font-size: 1rem;
}
</style>